import { render, staticRenderFns } from "./NewJob.vue?vue&type=template&id=aafd0c24&scoped=true&"
import script from "./NewJob.vue?vue&type=script&lang=js&"
export * from "./NewJob.vue?vue&type=script&lang=js&"
import style0 from "./NewJob.vue?vue&type=style&index=0&id=aafd0c24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafd0c24",
  null
  
)

export default component.exports